import { InjectionToken, inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";

/**
 * Provide DOM Window reference.
 */
export const NG_WINDOW = new InjectionToken<Window>("ng-window", {
  providedIn: "root",
  factory: () => {
    const { defaultView } = inject(DOCUMENT);

    if (!defaultView) {
      throw new Error("Window is not available");
    }

    return defaultView;
  },
});
